export const PRODUCT_CARDS = {
    DEFAULT: 'card-1',
    WITH_ACTION: 'card-2'
}

export const TESTIMONY_CARDS = {
    DEFAULT: 'default',
    ALTERNATIVE: 'alternative'
}